<am-expandable-group [selectedExpandable]="selected" name="mealPlan" size="short">
  <h6 title>
    {{ mealPlanName }}
  </h6>
  <span static>
    @if (mealPlanName === enumDisneyMealPlan.DISNEY_DINING_PLAN ||
        mealPlanName === enumDisneyMealPlan.TABLE_SERVICE_DINING_PLAN) {
    <p>
      Incluí 1 comida en los famosos restaurantes de Disney, junto a una experiencia exclusiva y 1 snack, diario en tu reserva.
    </p>
    }

    @if (mealPlanName === enumDisneyMealPlan.DELUXE_TABLE_SERVICE_DINING_PLAN) {
    <p>Incluí 2 comidas en los famosos restaurantes de Disney, junto a una experiencia exclusiva y un 1 snack, diario en tu reserva.
    </p>
    }

    @if (mealPlanName === enumDisneyMealPlan.QUICK_SERVICE_DINING_PLAN) {
    <p>Incluí 2 comidas y un snack diario en tu reserva.</p>
    }
  </span>
  <span body>
    @if (mealPlanName === enumDisneyMealPlan.DISNEY_DINING_PLAN) {
    <div class="container-list">
      <ul>
        <li>
          <mb-icon class="check" [icon]="check"></mb-icon>
          <span
            ><p>
              <strong> 1 Comida con servicio de mesa.</strong>
            </p></span
          >
        </li>
        <li>
          <mb-icon class="check" [icon]="check"></mb-icon>
          <span
            ><p>
              <strong> 1 Comida rápida.</strong>
            </p></span
          >
        </li>
        <li>
          <mb-icon class="check" [icon]="check"></mb-icon>
          <span
            ><p>
              <strong>1 Snack o bebida especial</strong>
            </p></span
          >
        </li>
        <li>
          <mb-icon class="check" [icon]="check"></mb-icon>
          <span>
            <p>
              <strong>1 Vaso recargable.</strong>
            </p>
          </span>
        </li>
        <li>
          <mb-icon class="star" [icon]="magic"></mb-icon>
          <span
            ><p>
              Plus, Además puedes canjear 2 servicios de mesa por una
              <strong>experiencia gastronómica especial</strong>. Incluye cena con algún personaje.
            </p></span>
        </li>
      </ul>
    </div>
    }
    @if (mealPlanName === enumDisneyMealPlan.QUICK_SERVICE_DINING_PLAN) {
    <div class="container-list">
      <ul>
        <li>
          <mb-icon class="check" [icon]="check"></mb-icon>
          <span
            ><p><strong>2 Comidas rápidas</strong> (sin servicio de mesa).</p></span
          >
        </li>
        <li>
          <mb-icon class="check" [icon]="check"></mb-icon>
          <span
            ><p>
              <strong>1 Snack o Bebida especial</strong>
            </p></span
          >
        </li>
        <li>
          <mb-icon class="check" [icon]="check"></mb-icon>
          <span>
            <p>
              <strong>1 Vaso recargable oficial del resort por persona.</strong>
            </p>
          </span>
        </li>
        <li>
          <mb-icon class="close" [icon]="close"></mb-icon>
          <span>
            <p><strong>No incluye</strong> experiencia gastronómica especial.</p>
          </span>
        </li>
      </ul>
    </div>
    }
    @if (mealPlanName === enumDisneyMealPlan.TABLE_SERVICE_DINING_PLAN) {
    <div class="container-list">
      <ul>
        <li>
          <mb-icon class="check" [icon]="check"></mb-icon>
          <span
            ><p><strong>1 Comida con servicio de mesa.</strong></p></span
            >
        </li>
        <li>
          <mb-icon class="check" [icon]="check"></mb-icon>
          <span
            ><p>
              <strong>1 Comida rápida.</strong>
            </p></span
          >
        </li>
        <li>
          <mb-icon class="check" [icon]="check"></mb-icon>
          <span>
            <p>
              <strong>1 Snack o bebida especial.</strong>
            </p>
          </span>
        </li>
        <li>
          <mb-icon class="check" [icon]="check"></mb-icon>
          <span>
            <p>
              <strong>1 Vaso recargable.</strong>
            </p>
          </span>
        </li>
        <li>
          <mb-icon class="star" [icon]="magic"></mb-icon>
          <span>
            <p>
              Plus, Ademas podes canjear 2 servicios de mesa por una
              <strong>experiencia gastronomica especial</strong>.  Incluye cena con algún personaje.</p>
          </span>
        </li>
      </ul>
    </div>
    }
    @if (mealPlanName === enumDisneyMealPlan.DELUXE_TABLE_SERVICE_DINING_PLAN) {
    <div class="container-list">
      <ul>
        <li>
          <mb-icon class="check" [icon]="check"></mb-icon>
          <span
            ><p><strong>2 Comidas con servicio de mesa.</strong></p></span
            >
        </li>
        <li>
          <mb-icon class="check" [icon]="check"></mb-icon>
          <span
            ><p>
              <strong>1 Comida rápida.</strong>
            </p></span
          >
        </li>
        <li>
          <mb-icon class="check" [icon]="check"></mb-icon>
          <span>
            <p>
              <strong>1 Snack o bebida especial.</strong>
            </p>
          </span>
        </li>
        <li>
          <mb-icon class="check" [icon]="check"></mb-icon>
          <span>
            <p>
              <strong>1 Vaso recargable.</strong>
            </p>
          </span>
        </li>
        <li>
          <mb-icon class="star" [icon]="magic"></mb-icon>
          <span>
            <p>
              Plus, Ademas podes canjear 2 servicios de mesa por una
              <strong>experiencia gastronomica especial</strong>.  Incluye cena con algún personaje.</p>
          </span>
        </li>
      </ul>
    </div>
    }
  </span>
  <div class="detail_meal_plan">
    @if (included) {
    <p class="btn">Ya incluído en tu tarifa</p>
    } @else {
      @if (!selected) {
      <button
        class="btn add-meal-plan"
        mb-button
        variant="outline"
        color="secondary"
        [disabled]="disabled"
        (click)="selectMealPlan()"
      >
        Agregar
      </button>
      } @else {
      <button
        class="btn"
        mb-button
        variant="floating"
        color="secondary"
        [disabled]="disabled"
        (click)="deleteMealPlan()"
      >
        Eliminar
      </button>
      }
    }
  </div>
</am-expandable-group>
